//carousel
if (typeof $ === 'function') {

  //get carousels
  var carousels = $('#carousel');
  //console.log(carousels);

  //initialize each carousel
  carousels.each(function () {

      //console.log('carousel.initstart');
      $(this).trigger('carousel.initstart');

      var carousel = $(this),
          intervalId = false,
          timeoutId = false,
          slides = carousel.find('.slide'),
          images = slides.filter('[src]').length ? slides : slides.find('img'),
          interval = carousel.data('interval') || 5000,
          //hp special gallery
          hpGalleryAuthor = $('.hpGallery_author'),
          hpGalleryTitle = $('.hpGallery_title'),
          hpGalleryDate = $('.hpGallery_date'),
          hpGalleryButton = $('.hpGallery_button'),
          replaceText = function (elm, text) {
            var oldText = '​' + elm.text(),
                interval = setInterval(function () {
                  if (oldText != '​') {
                    oldText = oldText.replace(/.$/, '');
                    elm.text(oldText);
                  } else {
                    elm.text(text.substr(0, elm.text().length + 1));
                  }
                  if (elm.text() == text) clearInterval(interval);
                }, 12);
            //console.log(oldText)
            //console.log(text)
            //elm.text(text)
          },
          slideNext = function (index) {
              //concurrency
              //if (timeoutId) clearTimeout(timeoutId);
              //
              var current = slides.filter('.current'),
                  next = index !== undefined ? slides.eq(index) : (current.next().length ? current.next() : slides.first()),
                  currentAuthor = hpGalleryAuthor.text(),
                  currentTitle = hpGalleryTitle.text(),
                  currentDate = hpGalleryDate.text(),
                  currentLink = hpGalleryTitle.attr('href'),
                  nextAuthor = $.trim(next.data('author')),
                  nextTitle = $.trim(next.data('title')),
                  nextDate = $.trim(next.data('date')),
                  nextLink = $.trim(next.data('link')),
                  nextBtnLabel = $.trim(next.data('btnlabel')),
                  nextIsInfo = $.trim(next.data('isinfo'));
              next.addClass('next');
              timeoutId = setTimeout(function () {
                current.removeClass('current');
                next.addClass('current').removeClass('next');
              }, 1000);
              //hp special gallery
              //if (hpGalleryAuthor.length) {
                //console.log(currentAuthor, currentTitle, nextAuthor, nextTitle);
                if (currentAuthor != nextAuthor) replaceText(hpGalleryAuthor, nextAuthor);
                if (currentTitle != nextTitle) replaceText(hpGalleryTitle, nextTitle);
                if (hpGalleryDate.length && currentDate != nextDate) hpGalleryDate.text(nextDate);
                if (currentLink != nextLink) {
                  hpGalleryTitle.attr('href', nextLink);
                  if (hpGalleryButton.length) {
                    hpGalleryButton.attr('href', nextLink);
                    hpGalleryButton.text(nextBtnLabel);
                    if (nextIsInfo) {
                      hpGalleryButton.addClass('btn-info');
                    } else {
                      hpGalleryButton.removeClass('btn-info');
                    }
                  }
                }
              //}
              //console.log('carousel.slide.shown');
              next.trigger('carousel.slide.shown');
          },
          pauseShow = function () {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = false;
                //console.log('carousel.paused');
                carousel
                  .addClass('paused')
                  .trigger('carousel.paused');
            }
          },
          continueShow = function () {
            if (!intervalId) {
                intervalId = setInterval(slideNext, interval);
                //console.log('carousel.continued');
                carousel
                  .removeClass('paused')
                  .trigger('carousel.continued');
            }
          },
          slideTo = function (index) {
            slideNext(index);
            setTimeout(pauseShow, 20);
            pauseShow();
          };
          //console.log(slides)
          //console.log(images)
          //console.log(hpGalleryAuthor)
          //console.log(hpGalleryTitle)

      //hp special gallery
      hpGalleryAuthor.text($.trim(hpGalleryAuthor.text()));
      hpGalleryTitle.text($.trim(hpGalleryTitle.text()));

      //stop init if no slides
      if (!slides.length) return false;

      //run show only when all images are loaded
      images.on('load', function () {
        $(this)
          .addClass('loaded')
          .trigger('carousel.image.loaded');
        //console.log('carousel.image.loaded')
        if (!images.not('.loaded').length) {

          //run show
          continueShow();

          //stop on mouseover, continue on mouseout
          carousel
            .on('mouseenter', pauseShow)
            .on('mouseleave', continueShow);

          //fancybox interaction
          $(window)
            .on('fancybox.show fancybox.shown', function () { setTimeout(pauseShow, 20); });
        }
      });

      //load other images
      images.each(function () {
          var t = $(this);
          if (t.data('src')) {
              t.attr('src', t.data('src'));
              //console.log('carousel.image.set');
              t.trigger('carousel.image.set');
          }
      });

      //public API
      if (typeof window.JRKIT === 'object') {
        window.JRKIT.carousel = {};
        window.JRKIT.carousel.slideTo = slideTo;
        window.JRKIT.carousel.pause = pauseShow;
      }

      //console.log('carousel.initalized');
      carousel.trigger('carousel.initalized');

  });
}
